/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author minhlnt2@ghtk.vn on 03/08/2022.
 * @module SMART SCALE CONSTANTS
 */

// Action constants
export const MODULE_NAME = "SMARTSCALE/";

export const SCALE_STATUS = {
  USING: {
    label: "Đang sử dụng",
    value: "USING",
    color: "#069255"
  },
  REPAIR: {
    label: "Đang sửa chữa",
    value: "REPAIR",
    color: "#ff0000"
  },
  NOT_USING: {
    label: "Không sử dụng",
    value: "NOT_USING",
    color: "#B5B5C3"
  },
  WAREHOUSING: {
    label: "Lưu kho",
    value: "WAREHOUSING",
    color: "orange"
  }
};

export const IMAGE_STATUS = {
  true: {
    label: "Có ảnh đơn hàng",
    value: true,
    color: "#069255"
  },
  false: {
    label: "Không có ảnh đơn hàng",
    value: false,
    color: "#ff0000"
  }
};

export const SCALE_CAMERA_STATUS = {
  0: {
    label: "Offline",
    value: 0,
    color: "#ff0000"
  },
  1: {
    label: "Online",
    value: 1,
    color: "#069255"
  }
};

export const SCALE_V2_CAMERA_STATUS = {
  OFFLINE: {
    label: "Offline",
    value: 0,
    color: "#ff0000"
  },
  ONLINE: {
    label: "Online",
    value: 1,
    color: "#069255"
  },
  DISCONNECT: {
    label: "Disconnect",
    value: 2,
    color: "#B5B5C3"
  }
};

export const SCALE_VIEW = {
  6: {
    label: "x 6",
    value: 6,
    span: 4,
    height: "42vh",
    font: "13px",
    station_font: "12px"
  },
  8: {
    label: "x 8",
    value: 8,
    span: 3,
    height: "35vh",
    font: "13px",
    station_font: "12px"
  },
  12: {
    label: "x 12",
    value: 12,
    span: 2,
    height: "30vh",
    font: "12px",
    station_font: "11px"
  }
};

export const SCALE_TYPE = [
  {
    label: "SCALE",
    value: "SCALE"
  },
  {
    label: "SMART SCALE",
    value: "SMART_SCALE"
  }
];

export const SMARTSCALE_CONTROLLER_STATUS = {
  ONLINE: {
    name: "Online",
    value: "ONLINE",
    color: "#069255"
  },
  DISCONNECT: {
    name: "Disconnect",
    value: "DISCONNECT",
    color: "#b5b5c3"
  },
  OFFLINE: {
    name: "Offline",
    value: "OFFLINE",
    color: "#ff0000"
  }
};

export const SMARTSCALE_LOG_TYPE = [
  {
    label: "Quét nhập 1 sp",
    value: 1
  },
  {
    label: "Quét nhập nhiều sp",
    value: 2
  },
  {
    label: "Quét xuất đơn hàng",
    value: 3
  },
  {
    label: "Quét nhập 1 sp nhưng thiếu mã sản phẩm sku/barcode",
    value: 4
  },
  {
    label: "Quét xuất đơn hàng: đơn hàng thiếu thông tin mã đơn",
    value: 5
  },
  {
    label: "Quét xuất đơn hàng: đơn hàng thiếu thông tin dimension",
    value: 6
  },
  {
    label: "Quét xuất đơn hàng: Không định dạng được đơn hàng",
    value: 7
  }
];
